module.exports = __webpack_public_path__ + "static/media/edit-content.e55eb700.svg";